<style>
    .default {
        background: rgba(206, 220, 208, 0.5);
    }

    .new-period-data-container {
        text-align: center;
    }
    .new-period-data-container > .xs6 > .v-picker {
        width: 90%;
    }

    .new-period-data-container > .xs6 > .v-picker > .v-picker__body {
        width: 90% !important;
    }
</style>

<template>
    <v-container fluid pa-0>
        <v-card>
            <v-toolbar class="elevation-1">
                <v-toolbar-title>Reporting Periods</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                        append-icon="search"
                        label="Search"
                        flat
                        v-model="search"
                        solo clearable
                ></v-text-field>
                <v-btn @click="dialog=true">Add Period</v-btn>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                :pagination.sync="pagination"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
                class="elevation-1">
                    <template slot="items" slot-scope="props">
                        <tr v-bind:class="{ 'default': props.item.id == defaultPeriod }">
                            <td>
                                <v-text-field v-bind:value="props.item.text" v-bind:ref="props.item.text" v-model="props.item.text"
                                @change="save(props.item)">
                                    {{ props.item.text }}
                                </v-text-field>
                            </td>
                            <td>
                                <v-flex>
                                    <v-menu
                                        ref="menu"
                                        v-bind:value="props.item.id"
                                        :close-on-content-click="true"
                                        lazy
                                        offset-y
                                        full-width
                                        v-model="props.item.menu"
                                        :nudge-right="40"
                                        :return-value.sync="props.item.startDate"
                                        transition="scale-transition"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            readonly
                                            v-bind:value="printFormatDate_DDMMYYYY(props.item.startDate)"
                                        ></v-text-field>            
                                        <v-date-picker no-title scrollable v-model="props.item.startDatePicker"
                                        @input="save(props.item);">
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </td>
                            <td>      
                                <v-flex>
                                    <v-menu
                                        ref="menu2"
                                        v-bind:value="props.item.id"
                                        :close-on-content-click="true"
                                        lazy
                                        offset-y
                                        full-width
                                        v-model="props.item.menu2"
                                        :nudge-right="40"
                                        :return-value.sync="props.item.endDate"
                                        transition="scale-transition"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            readonly
                                            v-bind:value="printFormatDate_DDMMYYYY(props.item.endDate)"
                                        ></v-text-field>
                                        <v-date-picker v-model="props.item.endDatePicker" no-title scrollable
                                        @input="save(props.item);">
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </td>
                            <td>
                                <v-text-field disabled v-bind:value="printFormatDate_DDMMYYYY(props.item.reportingDate)">

                                </v-text-field>
                            </td>
                            <td>
                                <v-switch
                                    v-model="actives"
                                    @change="activeInactivePeriod(props.item)"
                                    v-bind:value="props.item.id"
                                    color="success"
                                    hide-details
                                    solo
                                    v-bind:disabled="props.item.complete"
                                ></v-switch>
                            </td>
                            <td>
                                <v-switch
                                    v-model="props.item.complete"
                                    @change="selectReportingDate(props.item)"
                                    color="success"
                                    hide-details
                                    solo
                                ></v-switch>
                            </td>
                            <td>
                                <v-switch
                                    v-model="props.item.visible"
                                    @change="props.item.visible ? makeVisible(props.item) : makeInvisible(props.item)"
                                    color="success"
                                    hide-details
                                    solo
                                ></v-switch>
                            </td>
                            <td disabled>
                                <v-layout row>
                                    <v-tooltip bottom>
                                        <v-btn slot="activator" fab dark small color="red" outline
                                        @click.stop="loadDialogDelete(props.item)"
                                        v-bind:value="props.item.id"
                                        ><v-icon dark>delete</v-icon>
                                        </v-btn>    
                                        <span>Delete Reporting Period</span>
                                    </v-tooltip>
                                </v-layout>
                                
                            </td>
                        </tr>
                      
                    </template>
                </v-data-table>
        </v-card>
       
        <!-- Dialog to Add a new reporting period -->
        <v-dialog v-model="dialog" max-width="50%" persistent>
            <v-card ref="formNewPeriod">
                <v-card-title>
                    Add Reporting Period
                </v-card-title>
                <v-card-text>
                    <v-flex xs12 >
                        <v-text-field
                            ref="periodName"
                            label="Name"
                            v-model="periodName"
                            :rules="[() => !!periodName || 'This field is required']"
                            :error-messages="errorMessages"
                            required
                        ></v-text-field>
                    </v-flex>
                </v-card-text>
                
                <v-card-text>
                    <v-layout xs12 row class="new-period-data-container">
                        <v-flex xs6>
                            <p style="float: left; margin-left: 5%;"><b>Start Date</b></p>
                            <v-date-picker v-model="startDatePicker" no-title color="green lighten-1"></v-date-picker>
                            <v-alert style="width: 90%" v-model="noStartDateNotification" icon="warning" outline>
                                Please select a start date
                            </v-alert>
                        </v-flex>
                        <v-flex xs6>
                            <p style="float: left; margin-left: 5%;"><b>End Date</b></p>
                            <v-date-picker v-model="endDatePicker" no-title color="green lighten-1"></v-date-picker>
                            <v-alert style="width: 90%" v-model="noEndDateNotification" icon="warning" outline>
                                Please select an end date
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" flat @click.stop="resetForm(); dialog=false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="addPeriod()">Add</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog to delete a reporting period -->
        <v-dialog v-model="dialogDelete" max-width="35%">
            <v-card>
                <v-card-title>
                    Confirmation
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-layout row wrap>
                                This action will remove all the info related to the period &nbsp; <b>{{ delPeriodName }}</b>
                            </v-layout>
                    </v-layout>
                </v-card-text>
                <v-progress-linear
                :indeterminate="loading"
                :active="delProgress"
                ></v-progress-linear>
                <v-alert :value="true" type="success" dismissible v-model="alertSuccess">
                    {{ delSuccessMessage }}
                </v-alert>
                <v-alert :value="true" type="error" dismissible v-model="alertError">
                    {{ delErrorMessage }}
                </v-alert>
                <v-card-actions>
                    <v-btn color="primary" flat @click.stop="dialogDelete = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.stop="emptyPeriod()">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- This dialog is made to select a reporting date when a period is marked as complete -->
        <v-dialog ref="dateDialog" v-model="reportingDateDialog" 
            :return-value.sync="reportingDate" max-width="25%"
            persistent lazy full-width
            >
            <v-card>
                <v-card-title>Select Reporting Date</v-card-title>
                <v-card-text>
                    <v-layout row wrap0>
                        <v-date-picker v-model="reportingDate" title="Reporting Date" scrollable full-width>
                            <v-btn flat color="primary" @click="cancelCompleteRequest()">Cancel</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="makeComplete(reportingDate)">Continue</v-btn>
                        </v-date-picker>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- This dialog shows the progress of dashboard calculations when a reporting period is marked as complete or incomplete -->
        <v-dialog v-model="progressDialog" max-width="35%" persistent>
             <v-card>
                <v-card-title>
                    Updating Student Dashboard
                </v-card-title>
                <v-card-text align-center>
                     <v-layout row wrap>   
                            <br>
                            <br>
                            <br>
                            <v-progress-linear centered
                                :indeterminate="calculatingData"
                                color="green"
                            ></v-progress-linear>   
                    </v-layout>
                </v-card-text>
                <v-card-text v-if="showReport">
                    <div  class="table__overflow" v-html="progressReport"></div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>         
                    <v-btn color="primary" flat @click.native="finishCalculations()">Finish</v-btn>                    
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="notificationsDialog" max-width="35%">
            <v-card>
            <v-card-title>
                Notify users about new data available for viewing
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 class="my-1">
                    <v-flex xs12>
                    <v-text-field
                        label="Subject"
                        v-model="notificationSubject"
                        required
                    ></v-text-field>
                    </v-flex>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 class="my-2">
                   <v-textarea
                        height="5em"
                        name="input-7-1"
                        label="Message"
                        v-model="notificationMessage"
                        required
                    ></v-textarea>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-alert :value="true" type="success" dismissible v-model="notificationSuccess">
                {{ notifSuccessMessage }}
            </v-alert>
            <v-alert :value="true" type="error" dismissible v-model="notificationError">
                {{ notifErrorMessage }}
            </v-alert>
            <v-card-actions>
                <v-btn color="primary" flat @click.stop="notificationsDialog=false">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click.native="sendNotifications()">Send</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        
    </v-container>


</template>

<script>
import { getList, getPeriods, postReportingPeriod, putReportingPeriod, initialize } from '../utils/effort-tracking-api'
import { activatePeriod, deactivatePeriod, deletePeriod, makePeriodVisible } from '../utils/effort-tracking-api'
import { makePeriodComplete, getDashboardCalculationStatus, makePeriodIncomplete } from '../utils/effort-tracking-api'
import { stopDashboardCalculations, makePeriodInvisible, sendPeriodCompleteNotification } from '../utils/effort-tracking-api'
import { store } from '../store'
import moment from 'moment'
import { globalStore } from '../main';

export default {
    name: 'reporting-periods',
    data() {
        return {
            search: '',
            headers: [
                { text: 'Name', value: 'text', sortable: false },
                { text: 'Start Date', value:'startDate', sortable: false },
                { text: 'End Date', value:'endDate', sortable: false },
                { text: 'Reporting Date', value: 'reportingDate', sortable: false },
                { text: 'Active', value:'id', sortable: false },
                { text: 'Complete', value: 'complete', sortable: false },
                { text: 'Visible', value: 'visible', sortable: false },
                { text: 'Available Actions', value: '', sortable: false }
            ],
            items: [],
            loading: true,
            pagination: { rowsPerPage: globalStore.defaultRowsPerPage },
            rowsPerPageItems: globalStore.rowsPerPageItems,
            actives: [],
            dialog: false,
            periodName: '',
            startDatePicker: null,
            endDatePicker: null,
            menu: null,
            date: null,
            menu2: null,
            date2: null,
            dialogDelete: false,
            delPeriodName: '',
            delPeriodId: 0,
            loading: false,
            delProgress: false,
            delSuccessMessage: 'Reporting period deleted successfully',
            delErrorMessage: 'Something went wrong, please try again.',
            alertSuccess: false,
            alertError: false,
            defaultPeriod: 0,
            progressDialog: false,
            timer: '',
            reportingDateDialog: false,
            reportingDate: new Date().toISOString().substr(0, 10),
            selectedPeriod: null,
            progressReport: '',
            showReport: false,
            calculatingData: false,
            progressRetries: 0,
            maxProgressRetries: 0,
            notificationSubject: 'Effort Tracking Data Available',
            notificationMessage: '',
            notificationsDialog: false,
            periodComplete: false,
            notificationSuccess: false,
            notificationError: false,
            notifSuccessMessage: 'Notifications sent successfully.',
            notifErrorMessage: 'Something went wrong, please try again.',
            notificationPeriodId: 0,
            errorMessages: '',
            formHasErrors: false,
            noStartDateNotification: false,
            noEndDateNotification: false
        }
    },
    watch: {
        search() {
            this.debouncedGetDataFromApi();
        },
        pagination: {
            handler() {
                this.debouncedGetDataFromApi();
            },
            deep: true
        },
        endDatePicker: {
            handler() {
                console.log('Changed...');
                console.log(this.endDatePicker);
                this.noEndDateNotification = this.endDatePicker === null;
            }
        },
        startDatePicker: {
            handler() {
                console.log('Changed...');
                console.log(this.startDatePicker);
                this.noStartDateNotification = this.startDatePicker === null;
            }
        },
        actives: function( activePeriods ) {
            initialize().then(x => {
                 getPeriods().then( periods => {
                    store.state.periods = [];

                    periods.forEach(period => {
                    var p = {
                        text: period.text,
                        id: Number(period.value),
                        startDate: new Date(period.startDate),
                        endDate: new Date(period.endDate),
                        active: period.active,
                        complete: period.complete
                    };
                    store.state.periods.push(p);
                    });

                    this.$emit('actives-changed');
                });
            });
        },
        periodName () {
        this.errorMessages = ''
        }
    },
    mounted() {
        this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true })
        initialize().then(x => {
            getPeriods().then( periods => {
                localStorage.setItem('active-periods', '');
                store.state.periods = [];
                periods.forEach(period => {
                    var p = {
                        text: period.text,
                        id: Number(period.value),
                        startDate: new Date(period.startDate),
                        endDate: new Date(period.endDate),
                        active: period.active,
                        complete: period.complete
                    };

                    store.state.periods.push(p);

                    if(period.active)
                        this.actives.push(Number(period.value));
                });

                localStorage.setItem('active-periods', this.actives);
            });
        });
      
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    computed: {
        computedDateFormatted ( value ) {
            return this.formatDate( value )
        },
        formNewPeriod () {
            return {
            periodName: this.periodNamename
            }
        },
    },
    methods: {
        getDataFromApi() {
            this.loading = true;
            getList('periods', this.pagination, this.search).then( data => { 
                this.actives = [];
                data.items.forEach(element => {
                    element.startDatePicker = element.startDate;
                    element.endDatePicker = element.endDate;
                    element.startDate = this.formatDate_DDMMYYYY(element.startDate);
                    element.endDate = this.formatDate_DDMMYYYY(element.endDate);
                    element.reportingDate = this.formatDate_DDMMYYYY(element.reportingDate);
                });

                this.loading = false;
                data.items.filter(p => p.active).forEach(p => {
                    if(this.actives.indexOf(p.id) == -1)
                        this.actives.push(p.id);     
                });

                data.items.filter(p => !p.active).forEach(p => {
                    var index = this.actives.indexOf(p.id);
                    if(!p.active && index != -1)
                        this.actives.splice(index, 1);
                });

                var activesAndVisibles = data.items.filter(i => i.active && i.visible);
                if (activesAndVisibles.length > 0) 
                    this.defaultPeriod = activesAndVisibles[0].id;
                
                this.items = data.items;
                this.$store.state.periods = this.items;
                this.$emit('actives-changed');
            });
        },

        resetForm() {
            this.errorMessages = []
            this.formHasErrors = false;
            this.noStartDateNotification = false;
            this.noEndDateNotification = false;

            Object.keys(this.formNewPeriod).forEach(f => {
            this.$refs[f].reset()
            })
        },

        addPeriod() {
            
           this.formHasErrors = false;
           this.noStartDateNotification = false;
           this.noEndDateNotification = false;

           this.$refs["periodName"].validate(true);

           console.log('Adding period with data: ');
           console.log(this.startDatePicker);
           console.log(this.endDatePicker);

           this.noStartDateNotification = this.startDatePicker === null;
           this.noEndDateNotification = this.endDatePicker === null;
           this.formHasErrors = this.periodName == '' || this.periodName === null;

            if (this.periodName != '' && this.periodName != null && this.startDatePicker !== null && this.endDatePicker !== null)
            {
                var newPeriodModel = {
                    name: this.periodName,
                    startDate: this.startDatePicker,
                    endDate: this.endDatePicker,
                    active: true,
                };

                postReportingPeriod(newPeriodModel)
                .then( result => { 
                    this.dialog = false;
                    this.periodName= '';
                    this.startDatePicker= null;
                    this.endDatePicker= null;
                    this.errorMessages = []
                    this.formHasErrors = false

                    Object.keys(this.formNewPeriod).forEach(f => {
                    this.$refs[f].reset()
                    })
                    this.debouncedGetDataFromApi();
                    this.$emit('period-added');
                    this.$emit('actives-changed');
                });
            }
            // else
            // {
            //   this.formHasErrors = true;  
            // }

        },

        save(rp) {    
            let startDate = rp.startDatePicker;
            let endDate = rp.endDatePicker;
            let text = rp.text;
            let id = rp.id;
            let active = rp.active;
           
            var updatePeriodModel = {
                id: id,
                name: text,
                startDate: startDate,
                endDate: endDate,
                reportingDate: this.reportingDate,
                active: active
            };

            putReportingPeriod(updatePeriodModel).then(result => {
                this.getDataFromApi();
            }).catch( ex => console.log(ex) );
        },

        formatDate (date) {
            var lowerBound = moment('2000-01-01');

            if (!date) return null
            var parts = date.split('T');
            
            const [year, month, day] = parts[0].split('-')
            var formattedDate = `${year}-${month}-${day}`;

            var isValid = this.validDate(formattedDate, lowerBound);
            if (isValid) 
            {
                return formattedDate;
            } else {
                var today = moment(new Date());
                return today.format('YYYY-MM-DD');
            }
        },

        formatDate_DDMMYYYY (date)
        {
            var lowerBound = moment('2000-01-01');

            if (!date) return null
            var parts = date.split('T');
            
            const [year, month, day] = parts[0].split('-')
            var formattedDate = `${year}-${month}-${day}`;
            var formattedDate_DDMMYYYY = `${day}-${month}-${year}`;

            var isValid = this.validDate(formattedDate, lowerBound);
            if (isValid) 
            {
                return formattedDate_DDMMYYYY;
            } else {
                var today = moment(new Date());
                return today.format('DD-MM-YYYY');
            }
        },
        
        printFormatDate_DDMMYYYY (date)
        {
            var lowerBound = moment('2000-01-01');

            if (!date) return null
            var parts = date.split('T');
            
            const [day, month, year] = parts[0].split('-')
            var formattedDate = `${year}-${month}-${day}`;
            var formattedDate_DDMMYYYY = `${day}-${month}-${year}`;

            var isValid = this.validDate(formattedDate, lowerBound);
            if (isValid) 
            {
                return formattedDate_DDMMYYYY;
            } else {
                var today = moment(new Date());
                return today.format('DD-MM-YYYY');
            }
        },

        validDate(date, lowerBound) {
            var aDate   = moment(date, 'YYYY-MM-DD', true);
            var momentDate = moment(date);
            return aDate.isValid() && momentDate.diff(lowerBound) > 0
        },

        loadDialogDelete(period) {
            this.delProgress = false;
            this.alertSuccess = false;
            this.delPeriodName = period.text;
            this.delPeriodId = period.id;
            this.dialogDelete = true;
        },

        emptyPeriod() {
            this.loading = true;
            this.delProgress = true;
            deletePeriod(this.delPeriodId).then(response => {
                this.delProgress = false;
                this.alertSuccess = true;
                setTimeout(() => {    
                    this.dialogDelete = false;
                    var lsPeriod = localStorage.getItem('period-selected');
                    if(this.delPeriodId == lsPeriod)
                        this.$emit('selected-deleted');
                }, 3000);
                this.getDataFromApi();
                this.$emit('actives-changed');
            }).catch( ex => { 
                this.alertError = true;
            });
        },

        makeVisible(period) {
            makePeriodVisible(period.id).then(result => {
                this.getDataFromApi();
            }).catch( ex => {
                console.log(ex);
            });
        },
        makeInvisible(period) {
            makePeriodInvisible(period.id).then(result => {
                this.getDataFromApi();
            }).catch(ex => console.log(ex));
        },
        activeInactivePeriod(period)
        {
            period.active = !period.active;

            if (period.active) {
                activatePeriod(period.id).then(result => {
                    var activePeriods = localStorage.getItem('active-periods').split(',');
                    var index = activePeriods.indexOf(period.id.toString());
                    if(index == -1)
                        activePeriods.push(period.id.toString());

                    localStorage.setItem('active-periods', activePeriods);
                    this.getDataFromApi();
                    this.$emit('actives-changed');
                }).catch(ex => console.log(ex));
            } else {
                deactivatePeriod(period.id).then(result => {
                    var activePeriods = localStorage.getItem('active-periods').split(',');
                    var index = activePeriods.indexOf(period.id.toString());
                    if(index != -1)
                        activePeriods.splice(index, 1);

                    localStorage.setItem('active-periods', activePeriods);
                    this.getDataFromApi();
                    this.$emit('actives-changed');
                }).catch(ex => console.log(ex));
            }
        },
        selectReportingDate(period) {
            this.notificationPeriodId = period.id;
            if (period.complete)
            {
                this.selectedPeriod = period;
                this.reportingDateDialog = true;
            }else {
                this.makeIncomplete(period.id);
            }
        },

        makeComplete(reportingDate) {
            this.progressRetries = 0;
            this.maxProgressRetries = 3;
            this.progressReport = '';
            var period = this.selectedPeriod;
            this.reportingDateDialog = false;
            this.periodComplete = true;

            // Start Dashboard calculations
            this.progressDialog = true;
            makePeriodComplete(period, reportingDate).then(result => {
                this.timer = setInterval(this.dashboardProgress, 2000)
            
            }).catch(ex => console.log(ex));            
        },
        makeIncomplete(periodId) {
            this.progressReport = '';
            this.progressRetries = 0;
            this.maxProgressRetries = 3;
            this.progressDialog = true;
            this.calculatingData = true;
            this.periodComplete = false;
            makePeriodIncomplete(periodId).then(result => {
                this.timer = setInterval(this.dashboardProgress, 2000)
            }).catch(ex => console.log(ex))
        },
        cancelCompleteRequest() {
            this.reportingDateDialog = false;
            this.getDataFromApi();
        },
        dashboardProgress() {
            getDashboardCalculationStatus().then(progress => {
                this.calculatingData = true;
                this.showReport = true;
                this.progressReport = progress.report;

                if(!progress.isRunning) {
                    this.progressRetries++;
                    if(this.progressRetries > this.maxProgressRetries) {
                        clearInterval(this.timer);
                        this.calculatingData = false;
                        this.progressDialog = false;
                        if(this.periodComplete)
                        {
                            this.notificationMessage = `New data is available for viewing for the period ${this.selectedPeriod.text}. \n` 
                                + `You can login to the app to see your summaries.`;

                            this.notificationError = false;
                            this.notificationSuccess = false;
                            this.notificationsDialog = true;
                        }

                        this.getDataFromApi();
                        this.$emit('actives-changed');
                    }
                } 
            }).catch( ex => {
                clearInterval(this.timer);
                var message = ex.message
                if(ex.response)
                    message = ex.response.data == undefined ? ex : ex.response.data;
            });
        },
        finishCalculations(){
            this.progressReport = ''; 
            this.progressDialog = false;
            this.getDataFromApi();
            this.$emit('actives-changed');
        },
        stopCalculations() {
            stopDashboardCalculations(this.selectedPeriod.id).then(result => {
            }).catch(ex => console.log(ex));
        },
        sendNotifications() {
            sendPeriodCompleteNotification(this.notificationSubject, this.notificationMessage, this.notificationPeriodId)
            .then(response => { 
                if(response.success)
                {
                    this.notificationSuccess = true;
                } else {
                    this.notificationError = true;
                }

                setTimeout(() => {
                    this.notificationsDialog = false;
                }, 6000);
            }).catch(ex => console.log(ex));
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ReportingPeriods.vue